<template>
    <div class="content-wrapper">
        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <h3>Müşteri Bilgisi</h3>
                    </div>


                    <div class="col-md-12">
                        <div class="card p-3">
                            <div class="row">
                                <div class="col-md-12 d-flex align-items-center">
                                    <input v-model="customerCode" type="text" class="form-control w-25 mr-3"
                                        placeholder="Müşteri Kodu">

                                    <div class="d-flex align-items-center">
                                        <button class="btn btn-primary mr-2" @click="getCustomerInfo">
                                            <i class="fas fa-search"></i>
                                            <span>Search</span>
                                        </button>
                                        <button class="btn btn-danger" @click="reset">
                                            <i class="fas fa-times"></i>
                                            <span>Clear</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="customerData" class="col-md-12 mt-5">

                            <div class="card p-3">
                                <div class="row">
                                    <div class="col-md-12">
                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                            <li class="nav-item" role="presentation">
                                                <button class="nav-link active" id="user-bonues-tab" data-toggle="tab"
                                                    data-target="#user-bonuses" type="button" role="tab"
                                                    aria-controls="home" aria-selected="true">Kullanıcı Bonusu</button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <button class="nav-link" id="user-deposits-tab" data-toggle="tab"
                                                    data-target="#user-deposit" type="button" role="tab"
                                                    aria-controls="home" aria-selected="true">Kullanıcı Yatırımları</button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <button class="nav-link" id="user-withdraws-tab" data-toggle="tab"
                                                    data-target="#user-withdraws" type="button" role="tab"
                                                    aria-controls="home" aria-selected="true">Kullanıcı Çekimleri</button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <button class="nav-link" id="user-stats-tab" data-toggle="tab"
                                                    data-target="#user-stats" type="button" role="tab"
                                                    aria-controls="home" aria-selected="true">Kullanıcı İstatistikleri</button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-12">
                                        <div class="tab-content" id="myTabContent">
                                            <div class="tab-pane fade show active" id="user-bonuses" role="tabpanel"
                                                aria-labelledby="user-bonuses-tab">
                                                <UserBonuses :data="customerData.requests || []" />
                                            </div>
                                            <div class="tab-pane fade" id="user-deposit" role="tabpanel"
                                                aria-labelledby="user-deposit-tab">
                                                <UserDeposits :data="customerData.deposits || []" />
                                            </div>
                                            <div class="tab-pane fade" id="user-withdraws" role="tabpanel"
                                                aria-labelledby="user-withdraws-tab">
                                                <UserWithdraws :data="customerData.withdraws || []" />
                                            </div>

                                            <div class="tab-pane fade" id="user-stats" role="tabpanel"
                                                aria-labelledby="user-stats-tab">
                                                <UserStatistics :customerCode="customerCode" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import UserBonuses from './UserBonuses.vue';
import UserDeposits from './UserDeposits.vue';
import UserWithdraws from './UserWithdraws.vue';
import UserStatistics from './UserStatistics.vue';

export default {

    name: 'UserSetting',
    components: {
        UserBonuses,
        UserDeposits,
        UserWithdraws,
        UserStatistics
    },
    data() {
        return {
            overlay: false,
            customerData: null,
            customerCode: "",
        }
    },
    methods: {
        getCustomerInfo() {
            this.customerData = null;
            if (this.customerCode !== "") {
                this.overlay = true,

                    this.$http
                        .get(`Report/GetCustomer10Transactions?customerCode=${this.customerCode}`)
                        .then((response) => {
                            if (response) {
                                this.customerData = response.data
                            }
                            this.overlay = false;
                        },
                            (error) => {
                                console.log(error);
                                toastr.error(error.body.Message);
                                this.overlay = false;
                            });
            }
        },

        reset() {
            this.customerData = null
            this.customerCode = ""
        }
    }
};
</script>

<style scoped>
.min-h-sreen {
    height: calc(100vh - 20rem);
}
</style>


// WEBPACK FOOTER //
// src/components/UserProfile/UserSetting.vue